import React from 'react';
import styles from './HelpCenter.module.scss';
import {$getLanguage, $t} from '../../../helpers/translator';
import ClinicFaq from '../../../components/clinic/Faq/Faq';
import VideoGuide from '../../../components/clinic/VideoGuide/VideoGuide';
import Modal from '../../../components/miscellaneous/Modal/Modal';
import ContactUs from '../../../components/clinic/ContactUs/ContactUs';

class HelpCenter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: $getLanguage(),
            showContactUsModal: false
        };
    }

    renderContactUs() {
        return (
            <div className={'alma-box'}>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.service.contactUsTxt')}</h3></span>
                </div>
                <div className={`${styles['q-buttons-container']}`}>
                    <div className={`${styles['q-row']}`}>
                        <div className={`${styles['q-text']}`}>{$t('global.service.haveGeneralQuestion')}</div>
                        <div className={`alma-button ${styles['q-text']}`}
                             onClick={() => this.setState({showContactUsModal: true})}>
                            {$t('global.service.contactUsTxt')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    closeModals() {
        this.setState({
            showContactUsModal: false,
        });
    }

    render() {
        return (
            <div className={`${styles['container']}`}>
                <Modal content={<ContactUs onScreen={this.state.showContactUsModal}/>}
                       onClose={() => this.closeModals()}
                       visible={this.state.showContactUsModal}/>

                <div className={`${styles['row']}`}>
                    <div className={`${styles['box']}`} style={{maxWidth: 'none'}}>
                        {this.renderContactUs()}
                    </div>
                </div>

                <div className={`${styles['row']}`}>
                    <div className={`${styles['box']}`}>
                        <VideoGuide/>
                    </div>
                    <div className={`${styles['box']}`}>
                        <ClinicFaq/>
                    </div>
                </div>
            </div>
        );
    }
}

export default HelpCenter;
